import type { Nullable } from '@iheartjane/types';
import { useMediaQuery } from 'react-responsive';

export type IpadOrientation = Nullable<'portrait' | 'landscape'>;

/**
 * Provides a media query for iPad tablet sizes. The largest iPad at the moment has a screen width of 1024px.
 * @link https://www.ios-resolution.com/
 */
export const useIpadMediaQuery = (): IpadOrientation => {
  const isPortrait = useMediaQuery({
    query: `(max-width: 1024px)`,
    orientation: 'portrait',
  });
  const isLandscape = useMediaQuery({
    query: `(max-height: 1024px)`,
    orientation: 'landscape',
  });

  return isPortrait ? 'portrait' : isLandscape ? 'landscape' : null;
};
